import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'

class Klage extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleKlage = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var klage = this.props.klage
        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleKlage}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{klage.hvaKlagenGjelder} <Moment local>{klage.klageFortDato}</Moment></span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('klagefortdato')}</div>
                            <div className="value"><Moment local>{klage.klageFortDato}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('hvaklagengjelder')}</div>
                            <div className="value">{klage.hvaKlagenGjelder}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('klagereferanse')}</div>
                            <div className="value">{klage.klageReferanse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Klage)